import { Person } from "./person";
import { BeneficiaryKey } from "../Benefit/beneficiary-key";
import { Card } from "./card";

export class Dependent extends Person {
  private active: boolean;
  private beneficiaryKey: BeneficiaryKey;
  private beneficiarySocialNumber: string;
  private card: Card;
  private needValidateEmail: boolean;
  private enableDelivery: boolean;
  private transactionPasswordRequired: boolean;
  private limitType: number;
  private limit: number;

  getLimitType() : number {
    return this.limitType
  }

  setLimitType(limitType: number) : void {
    this.limitType = limitType
  }

  setLimit(value: number): void {
    this.limit = value;
  }

  getLimit(): number {
    return this.limit;
  }

  getTransactionPasswordRequired(): boolean {
    return this.transactionPasswordRequired;
  }
  setTransactionPasswordRequired(value: boolean): void {
    this.transactionPasswordRequired = value;
  }

  activate(): void {
    this.active = true;
  }

  deactivate(): void {
    this.active = false;
  }

  isActive(): boolean {
    return this.active;
  }

  setBeneficiaryKey(value: BeneficiaryKey): void {
    this.beneficiaryKey = value;
  }

  getBeneficiaryKey(): BeneficiaryKey {
    return this.beneficiaryKey;
  }

  setBeneficiarySocialNumber(value: string): void {
    this.beneficiarySocialNumber = value;
  }

  getBeneficiarySocialNumber(): string {
    return this.beneficiarySocialNumber;
  }

  setCard(value: Card): void {
    this.card = value;
  }

  getCard(): Card {
    return this.card;
  }

  isNew(): boolean {
    return !this.beneficiaryKey;
  }
  getNeedValidateEmail(): boolean {
    return this.needValidateEmail;
  }

  setNeedValidateEmail(value: boolean) {
    this.needValidateEmail = value;
  }
  getEnableDelivery(): boolean {
    return this.enableDelivery;
  }

  setEnableDelivery(value: boolean) {
    this.enableDelivery = value;
  }

  getIsDependent(): boolean {
    return true;
  }
}
